import * as React from "react";
import Table from "@mui/material/Table";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import WebAssetIcon from "@mui/icons-material/WebAsset";
import {
  Accordion,
  AccordionDetails,
  Typography,
  AccordionSummary,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

export default function Licenses(props) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const location = useLocation();
  let contractReference =
    location.pathname.split("/")[location.pathname.split("/").length - 2];
  let contractType = location.pathname
    .split("/")
    [location.pathname.split("/").length - 1].replace(/%20/g, " ");

  // The parse/stringify cheap cloning trick is to create a local copy of the state object
  let contract = useSelector((state) => {
    let _contract = state?.contracts?.find(
      (c) =>
        c.contract_reference === contractReference && c.type === contractType,
    );
    if (_contract) {
      return JSON.parse(JSON.stringify(_contract));
    } else return {};
  });

  const licenses = contract?.entitlements?.filter(
    (m) => m?.__typename === "License",
  );

  const nameRows = [
    { name: "License ID" },
    { name: "Creation Date" },
    { name: "Modification Date" },
    { name: "Entitlement Start Date" },
    { name: "Entitlement End Date" },
    { name: "Order ID" },
    { name: "Part Number" },
    { name: "Entitlement Status" },
  ];

  function handleSelectLicense(license_id) {
    dispatch(props.getLicenseDetails(license_id));
    navigate("/licenses/details/" + license_id);
  }

  const pendingLicenses =
    licenses?.filter(
      (license) => license.status?.toLowerCase() === "pending",
    ) || [];
  const activeLicenses =
    licenses?.filter((license) => license.status?.toLowerCase() === "active") ||
    [];

  return (
    <React.Fragment>
      <div style={{ width: "100%" }}>
        <TableContainer component={Paper}>
          <Accordion defaultExpanded={true}>
            <AccordionSummary
              style={{
                backgroundColor: "#6b469e",
                color: "white",
                height: "3vh",
              }}
              sx={{
                "&.Mui-expanded": {
                  minHeight: 0,
                },
                "&.MuiAccordionSummary-root": {
                  minHeight: 0,
                },
              }}
              expandIcon={<ExpandMoreIcon style={{ color: "white" }} />}
            >
              <Typography
                style={{
                  width: "100%",
                }}
              >
                <WebAssetIcon
                  style={{ marginRight: "1%", verticalAlign: "middle" }}
                />
                Licenses
              </Typography>
            </AccordionSummary>
            <Typography>
              Total licenses: {licenses?.length ?? 0}, of which pending:{" "}
              {pendingLicenses.length}, and active: {activeLicenses.length}
            </Typography>
            <AccordionDetails>
              <Table
                sx={{ minWidth: "30%" }}
                size="small"
                aria-label="contracts table"
              >
                <TableRow>
                  {nameRows?.map((row) => {
                    return (
                      <TableCell
                        component="th"
                        scope="row"
                        align="center"
                        style={{ fontWeight: "bolder" }}
                      >
                        {row.name}
                      </TableCell>
                    );
                  })}
                </TableRow>
                {licenses?.map((license) => {
                  const valueRows = [
                    { value: license?.license_id },
                    { value: license?.creation_date },
                    { value: license?.modification_date },
                    { value: license?.entitlement_start_date },
                    { value: license?.entitlement_end_date },
                    { value: license?.order?.order_id },
                    { value: license?.part_number },
                    { value: license?.status },
                  ];
                  return (
                    <>
                      <TableRow
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                        hover
                        style={{
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          handleSelectLicense(license?.license_id);
                        }}
                      >
                        {valueRows?.map((row, i) => {
                          return (
                            <TableCell
                              align="center"
                              style={{ position: "relative" }}
                            >
                              {row.value}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    </>
                  );
                })}
              </Table>
            </AccordionDetails>
          </Accordion>
        </TableContainer>
      </div>
    </React.Fragment>
  );
}
